// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  if (typeof state !== "number") {
    return state;
  }
  switch (state) {
    case /* Init */0 :
        if (typeof action === "number") {
          if (action !== 2) {
            if (action >= 3) {
              return /* UpdatingStatus */3;
            } else {
              return state;
            }
          } else {
            return /* Prioritising */2;
          }
        } else {
          return state;
        }
    case /* Submitting */1 :
        if (typeof action === "number") {
          return state;
        } else if (action.TAG === /* SetPrioritiseError */0) {
          return {
                  TAG: /* PrioritiseError */0,
                  _0: action._0
                };
        } else {
          return {
                  TAG: /* UpdateStatusError */1,
                  _0: action._0
                };
        }
    case /* Prioritising */2 :
    case /* UpdatingStatus */3 :
        if (typeof action === "number") {
          if (action !== 1) {
            if (action !== 0) {
              return state;
            } else {
              return /* Init */0;
            }
          } else {
            return /* Submitting */1;
          }
        } else {
          return state;
        }
    
  }
}

export {
  reducer ,
  
}
/* No side effect */
